var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spinner-a",style:({ 'background-color': _vm.color || false })}),_c('div',{staticClass:"spinner-b",style:({ 'background-color': _vm.color || false })}),_c('div',{staticClass:"spinner-c",style:({ 'background-color': _vm.color || false })})])
}
var staticRenderFns = []

export { render, staticRenderFns }